<template>
  <div>
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div style="background-color: #FFFFFF;">
      <div class="peifu-container" style="padding-bottom: 80px;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>机制币送评</span>收费标准</div>
        </div>
      </div>
    </div>
    <!-- <img style="width: 100%; margin-top: -50px;" src="@/assets/image/border-bj-3.png" alt=""> -->
    <div style="background-color: #FFFAF4; padding-bottom: 50px;">
      <div style="width: 1200px; margin: 0 auto;">
        <p class="p-ty" style="padding: 0 30px; margin-bottom: 50px;">本收费标准，适用于送评水石评级的银元、纪念币、金银币、铜元、镍币、外币等机制币。</br>按钱币真品公允市场估值分为5档收费，无论最终鉴定真假，评级服务费正常收取。</p>
        <img src="@/assets/image/shoufei-yinyuan.png" alt="" style="width: 1200px; margin: 0 auto 60px auto;" />
        <!-- 附件 -->
        <ul class="fu-list" style="padding: 0 40px; margin-top: 50px;">
          <li>备注：</li>
          <li class="fu-item">1.批量送评：</br>单次同品类送评（单枚价值500元以内）≥50枚，费用为25元/枚；</li>
          <li class="fu-item">2.低值批量：</br>单次同品类送评（单枚价值100元以内）≥100枚，费用为15元/枚；</li>
          <li class="fu-item">3.更换新封装盒，50元/枚；</li>
          <li class="fu-item">4.常规版别标板免费，特殊版别标版收费20元/枚；</li>
          <li class="fu-item">5.定制化服务：水石评级提供有偿定制化服务（如藏品添加参加姓名），后若更名或叠加藏家姓名，将按新送评收取评级费。</li>
        </ul>
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.peifu-container{
  width: 100%;
  background-image: url('@/assets/image/border-bj-3.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: bottom;
}
.shoufei-title{
  font-size: 28px;
  font-weight: bold;
  color: #907B47;
  margin-bottom: 20px;
  letter-spacing: 2px;
}
.shoufei-4{
  display: flex;
  align-items: center;
  border: 1px solid #DDAF58;
  padding: 0 150px 0 50px;
  height: 80px;
  line-height: 78px;
  position: relative;
  div{
    font-size: 16px;
    span{
      font-size: 26px;
      font-weight: bold;
      padding-right: 30px;
    }
  }
  img{
    width: 120px;
    position: absolute;
    right: 30px;
    bottom: 0;
  }
}
.fu-list{
  margin-top: 80px;
}
.fu-item{
  letter-spacing: 1px;
  font-size: 16px;
  margin: 5px 0 25px;
  line-height: 30px;
}
</style>